<template>
    <div class="m-topicSet">
        <div class="page-table">
            <div class="page-operate">
                <div class="operate-left">
                    <el-button @click="editTopicSet(0)" size="small" type="primary" >
                        <i class="nucfont inuc-add"></i> 添加题组
                    </el-button>
                </div>

                <div class="operate-right">
                    <el-input class="filter-name" v-model="formSearch.name"
                              @keyup.enter.native="getTopicList"
                              :placeholder="$t('tip.name')" size="small" clearable>
                        <el-button slot="append" @click="getTopicList" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-radio-group v-model="formSearch.isOnlyMine" @change="getTopicList" size="small">
                        <el-radio-button :label="false">全部</el-radio-button>
                        <el-radio-button :label="true">我的</el-radio-button>
                    </el-radio-group>
                </div>
            </div>

            <data-tables class="form-table"
                         ref="topicSetTable"
                         :data="tableData"
                         :table-props="tableProps"
                         :current-page="1"
                         :page-size="20"
                         :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
            >

                <el-table-column prop="name" label="题组名称" align="center" min-width="160px" show-overflow-tooltip :fixed="columnFixed"></el-table-column>

                <el-table-column prop="typeName" label="题组类型" align="center" width="105"></el-table-column>

                <el-table-column prop="topicType" label="考题类型" align="center" width="110px" sortable="custom">
                    <template #default="{row}">
                        <type-tag
                            type="paperType"
                            :id="row.topicType"
                            :name="row.topicTypeName"
                        ></type-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="size" label="题数" align="center" sortable="custom"></el-table-column>

                <template v-if="isDaily">
                    <el-table-column prop="topicPoint" label="每题分值" align="center" sortable="custom" width="105"></el-table-column>
                    <el-table-column prop="dailyLimit" label="每日积分上限" align="center" sortable="custom" width="130"></el-table-column>
                    <el-table-column prop="daily" label="题目生效时段" align="center" width="220">
                        <template #default="{row}">{{row.startTime | date}} ~ {{row.endTime | date}}</template>
                    </el-table-column>
                </template>

                <el-table-column prop="creatorName" label="创建人" align="center"></el-table-column>

                <el-table-column prop="content" label="描述" align="center" show-overflow-tooltip></el-table-column>

                <el-table-column v-if="isPersonal" prop="policy" label="权限" align="left" sortable="custom">
                    <template #default="{row}">
                        <div class="policy">
                            <p v-if="row.policy===0" class="private">
                                <i class="nucfont inuc-password2"></i>{{row.policyName}}
                            </p>
                            <p v-if="row.policy===1" class="readonly">
                                <i class="nucfont inuc-watch"></i>{{row.policyName}}
                            </p>
                            <p v-if="row.policy===2" class="public">
                                <i class="nucfont inuc-public"></i>{{row.policyName}}
                            </p>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column v-if="!isPersonal" prop="isPublish" label="发布状态" align="center" sortable="custom" :fixed="columnFixed ? 'right': false">
                    <template #default="{row}">
                         <span class="type-publish" :class="row.isPublish?'publish':'unpublish'">
                            {{ row.isPublish ? '已发布': '未发布' }}</span>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('c.operation')" align="center" width="150px" :fixed="columnFixed ? 'right': false">
                    <template #default="{row}">
                        <div class="btn-cell">
                            <i class="nucfont inuc-preview" :title="$t('c.view')"
                               @click="viewTopicSet(row.id)"></i>

                            <i class="nucfont inuc-edit" v-if="row.canEdit"
                               :title="$t('c.edit')"
                               @click="editTopicSet(row.id)"></i>

                            <template v-if="!isPersonal && row.canEdit">
                                <!-- 发布 -->
                                <i class="nucfont inuc-publish"
                                   v-if="!row.isPublish"
                                   :title="$t('c.publish')"
                                   @click="publishTopicSet(row.id, true)">
                                </i>

                                <!-- 取消发布 -->
                                <i class="nucfont inuc-fanhui"
                                   v-if="row.isPublish"
                                   :title="$t('c.unpublish')"
                                   @click="publishTopicSet(row.id, false)">
                                </i>
                            </template>

                            <!-- 删除 -->
                            <i class="nucfont inuc-delete" v-if="row.canEdit"
                               :title="$t('c.delete')"
                               @click="deleteTopicSet(row.id)"></i>
                        </div>
                    </template>
                </el-table-column>
            </data-tables>
        </div>

        <topic-set-edit
            v-model="topicSetDialog"
            :currentID="currentID"
            :type="type"
            @success="getTopicList"
        ></topic-set-edit>

    </div>
</template>

<script>
import TopicSetEdit from "./TopicSetEdit";
import {Debounce, Ticket} from "@/utils";

export default {
    components: {
        TopicSetEdit
    },

    props: {
        type: {
            type: Number,
            default: 2
        }
    },

    data() {
        return {
            formSearch: {
                name: '',
                isOnlyMine: false
            },
            tableData: [],
            tableProps: {
                border: true,
                stripe: true,
                rowKey: row => row.id,
                height: 'auto'
            },

            currentID: 0,
            topicSetDialog: false,

            userInfo: this.$ticket.get(),
            columnFixed: false,
        }
    },

    computed: {
        isPersonal() {
            return this.type === 2
        },
        isDaily() {
            return this.type === 3
        }
    },

    mounted() {
        this.getTopicList()

        this.setColumnFixed()
    },


    methods: {
        getTopicList() {
            let queryData = {
                ...this.formSearch,
                type: this.type
            }

            this.$api.getTopicSetList(queryData).then(res => {
                let data = res.package

                this.tableData = data.map(item => {
                    /** 一、个人题组权限
                     *     0、私有 只有自己可以编辑
                     *     1、共享只读 自己、管理员、超管
                     *     2、共享编辑 全部
                     *  二、背题练习及每日一练权限
                     *     自己、管理员、超管
                     */
                    let isAdmin = this.userInfo.type === 1 || this.userInfo.type === 4
                    let isMy = this.userInfo.userID === item.creatorID
                    item.canEdit = false

                    if (this.isPersonal) {
                        item.canEdit = (item.policy === 0 && isMy)
                            || (item.policy === 1 && (isMy || isAdmin))
                            || (item.policy === 2);
                    } else {
                        item.canEdit = isMy || isAdmin
                    }

                    // 把daily对象拍平
                    if (this.isDaily) {
                        item.topicPoint = item.daily.topicPoint
                        item.dailyLimit = item.daily.dailyLimit
                        item.startTime = item.daily.startTime
                        item.endTime = item.daily.endTime
                        item.singleModeLimited = item.daily.singleModeLimited
                        item.topicTimeLimit = item.daily.topicTimeLimit
                        item.pattern = item.daily.pattern
                    }

                    return item
                })
            })
        },

        editTopicSet(id) {
            this.currentID = id
            this.topicSetDialog = true
        },

        async publishTopicSet(id, isPublish) {
            let tip = isPublish ? '确定发布该题组吗？': '确定取消发布吗？'
            await this.$confirm(tip, this.$t('m.tip'), {type: 'warning'})

            await this.$api.publishTopicSet(id, isPublish)
            this.$message.success('操作成功！')
            this.getTopicList()
        },

        viewTopicSet(id) {
            if (this.isDaily) {
                this.$router.push({name: 'dailyTopicSetDetail', params: {id}})
            } else {
                this.$router.push({name: 'topicSetDetail', params: {id}})
            }
        },

        async deleteTopicSet(id) {
            await this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {type: 'warning'})
            await this.$api.deleteTopicSet(id)
            this.$message.success(this.$t('m.delSuccess'))
            this.getTopicList()
        },

        /**
         *  如果column设置了 `fixed`，table布局变化会导致行错乱
         *  一般情况下elTable.doLayout()就可解决
         *  但是这里有个bug，若设了fixed但是页面足够宽没触发fixed，table隐藏后再显示，会引发行错乱
         *  所以根据宽度动态设置fixed
         **/
        setColumnFixed() {
            if (this.isDaily) {
                let clientWidth = document.documentElement.clientWidth
                this.columnFixed = clientWidth < 1680

                $(window).on('resize.topicSet', Debounce(() => {
                    let clientWidth = document.documentElement.clientWidth
                    this.columnFixed = clientWidth < 1680

                    // 一般情况下用这个就行
                    // this.$nextTick(() => {
                    //     this.$refs.topicSetTable.$refs.elTable.doLayout()
                    // })
                }, 300))

                this.$once('hook:beforeDestroy', () => {
                    $(window).off('resize.topicSet')
                })
            }
        },

        onSubpageClose() {
            if (this.$ticket.get()) this.getTopicList()
        }
    },
}
</script>

<style lang="scss">
.m-topicSet {
    display: flex;
    flex-direction: column;
    height: 100%;

    .page-search {
        padding: 20px 20px 0 20px;
    }

    .page-table {
        box-shadow: none;
    }

    .page-operate {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;

        .operate-left {
            button {
                width: auto;
            }
            .nucfont {
                margin-right: 3px;
                font-size: 14px;
            }
        }

        .operate-right {
            .filter-name {
                width: 240px;
                margin-right: 20px;
            }
        }
    }

    .sc-table .btn-cell i.nucfont {
        padding: 0 6px;
    }

    .topicSet-form {
        margin-right: 40px;
    }

    .policy {
        .nucfont {
            margin-right: 2px;
            color: #666;
            font-size: 14px;
        }

        .private {
            &, .nucfont {
                color: $red;
            }
        }
        .readonly {
            &, .nucfont {
                color: $orange;
            }
        }
        .public {
            &, .nucfont {
                color: $blue;
            }
        }
    }

    .type-publish {
        &.publish {
            //color: #333;
            //font-weight: 600;
        }
        &.unpublish {
            color: #aaa;
        }
    }

}
</style>
